import { BackButton } from 'atoms/BackButton';
import { useLazyGetConsentHooks } from 'hooks/U015/useLazyGetConsentHooks';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import LoadingModal from 'organisms/LoadingModal';
import MessageModal from 'organisms/MessageModal';
import { TermsParser } from 'organisms/u002/TermsParser';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from 'templates/AppContextProvider';
import { AppLogoHeader } from 'templates/AppLogoHeader';
import { Form } from 'templates/Form';
import { PageContent } from 'templates/PageContent';
import { UnauthAppFooter } from 'templates/UnauthAppFooter';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

export function PrivacyNotice() {
  const { t: tCommons } = useTranslationWithLang('commons');
  const { currentLang } = useContext(AppContext);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [privacyNoticeData, privacyNoticeLoading, privacyNoticeErr, getPrivacyNotice] =
    useLazyGetConsentHooks({ lang: currentLang, consent_type: '1' }); // 1: プライバシーポリシー
  const navigate = useNavigate();

  useEffect(() => {
    getPrivacyNotice();
  }, [currentLang]);

  useEffect(() => {
    if (privacyNoticeErr?.message) {
      setShowErrorModal(true);
    }
  }, [privacyNoticeErr]);

  return (
    <>
      {privacyNoticeLoading && <LoadingModal />}
      {showErrorModal && (
        <MessageModal
          message={tCommons('TU000_058')}
          closeLabel={tCommons('TU000_028')}
          onClose={() => setShowErrorModal(false)}
        />
      )}
      <AppLogoHeader />
      <div role="heading" aria-level={1} aria-live="assertive" className="sr-only">
        {tCommons('TU000_065')}
      </div>
      <PageContent>
        <Form title={tCommons('TU000_065')}>
          <div className="max-h-96 overflow-y-scroll my-10">
            <TermsParser text={privacyNoticeData?.consent ?? ''} />
          </div>
        </Form>
        <div className="flex justify-center">
          <BackButton
            onClick={() => {
              Cookies.remove('OptanonAlertBoxClosed');
              console.log('OptanonAlertBoxClosed', Cookies.get('OptanonAlertBoxClosed'));
              navigate(-1);
            }}
          />
        </div>
      </PageContent>
      <UnauthAppFooter />
    </>
  );
}
